import MuiListItemText from "@mui/material/ListItemText";
const ListItemText = MuiListItemText;
export default ListItemText;
